export const USAGE_PREVIEW_CONFIG = {
  sold: {
    currentLabel: 'Current Sold',
    newLabel: 'New Sold',
    currentKey: 'currentUsage',
    newKey: 'newUsage',
    productField: 'sold',
    previewTitle: 'Preview: Ingredient Usage',
    previewEmptyText: 'Enter quantities above to see ingredient usage preview.',
    previewErrorText:
      'Unable to calculate preview. Please check your recipe data.',
    usageQtyColumnLabel: 'Usage Qty',
    updateDescription: 'sold quantities',
    recipesIncludedLabel: 'Recipes included:',
  },
  wastage: {
    currentLabel: 'Current Wastage',
    newLabel: 'New Wastage',
    currentKey: 'currentUsage',
    newKey: 'newUsage',
    productField: 'wastage',
    previewTitle: 'Preview: Ingredient Wastage',
    previewEmptyText:
      'Enter wasted quantities above to see ingredient wastage preview.',
    previewErrorText:
      'Unable to calculate wastage preview. Please check your recipe data.',
    usageQtyColumnLabel: 'Wastage Qty',
    updateDescription: 'wastage quantities',
    recipesIncludedLabel: 'Wasted recipes included:',
  },
}

export const getUsagePreviewConfig = usageField =>
  USAGE_PREVIEW_CONFIG[usageField] || USAGE_PREVIEW_CONFIG.sold
